export const Skeleton = (props) => {
  return <div style={{ height: props.height, width: props.width, backgroundColor: props.color ? props.color : '#f1f2f3', borderRadius: 7, display: 'inline-block' }}></div>
}